module.exports = __webpack_public_path__ + "static/media/img5.6e5c00d2.jpg";